import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "After five months, my effective hourly rate with a publisher is 3eur/hour",
  "description": "",
  "published": "2014-03-24T00:00:00.000Z",
  "redirect_from": ["/blog/after-five-months-my-effective-hourly-rate-with-a-publisher-is-3eurhour/swizec/6548"],
  "categories": "Book, Business, d3.js, Data Visualization, Packt, Publishing, Side Projects, Writing",
  "hero": "./img/images-13110.png"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`A while ago I wrote `}<a parentName="p" {...{
        "href": "http://www.packtpub.com/data-visualization-with-d3js/book"
      }}>{`a book about creating d3.js visualizations`}</a>{`. You can read about the writing, editing, and hair-pulling part of the process, `}<a parentName="p" {...{
        "href": "http://swizec.com/blog/i-published-a-book-with-a-publisher-heres-what-the-journey-was-like/swizec/6398"
      }}>{`here`}</a>{`.`}</p>
    <p>{`By the time it was published, I no longer liked my book. The didactic approach needed work, the examples were kind of meh, and too much of the content had to be breezy. When a `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Publishing",
        "title": "Publishing"
      }}>{`publisher`}</a>{` gets a fixed idea about book length, pushback is hard. Still managed to make it 70 pages longer than they wanted, though.`}</p>
    <p>{`Either way, the book has been out for five months now and with no word from the publisher, I was certain it tanked. An utter failure.`}</p>
    <p><a parentName="p" {...{
        "href": "http://www.packtpub.com",
        "title": "Packt"
      }}>{`Packt`}</a>{`'s official statement on keeping me in the loop was, `}<em parentName="p">{`"You will get a `}<a parentName="em" {...{
          "href": "http://en.wikipedia.org/wiki/Royalties",
          "title": "Royalties"
        }}>{`royalty`}</a>{` statement every quarter"`}</em>{`.`}</p>
    <p>{`Gee, thanks. That is very satisfying to both my inner data nerd and my ego. But probably good for peace of mind.`}</p>
    <p>{`Other than a `}<em parentName="p">{`"Hey we have some errata"`}</em>{` every once in a while, the book became completely invisible to me after publication. Just floating in the aether doing ... something.`}</p>
    <p>{`No discernible buzz. No marketing that I could see. For some reason I haven't even seen the book yet. I literally have `}<em parentName="p">{`no`}</em>{` idea how this thing turned out.`}</p>
    <p>{`In December the first royalty statement arrived.`}</p>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "707px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/f19e500a46ea5e7a40aa8e2203909e4b/394f7/images-13110.png",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "47.98206278026906%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'191\\'%20viewBox=\\'0%200%20400%20191\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M3%2017v14h395V3H3v14m1%200v12h393V5H4v12M3%2040v7h395V33H3v7m1%200v6h393V35l-197-1H4v6M3%2097v47h395V50l-198-1H3v48m1%200v45h393V51H4v46m1-26v18h391V52H5v19m1%200v17h388V53H6v18m260-15l-1%203c0%202%200%202%201%201h12l3%201%203-1h1l5%201c5%200%205%200%205-2-1-2-6-3-6%200h-1c0-3-18-3-18%200l-1-1c-1-2-2-4-3-2m96%200l-1%203c0%202%200%202%205%202%204-1%205%200%205%201h1l4-1%204-1h1l6%201c5%200%206%200%206-2s-1-2-4-2l-4-1h-2l-3%201a575%20575%200%2000-15-1h-3M5%20117v24h391V92H5v25m1%200v23h388v-3c0-1%200-2-1-1l-4%201c-2%200-3%200-3-2%200-3%201-4%203-3h4c1%201%201%201%201-3v-5l-4%201c-4%200-4%200-4-2%200-3%200-3%204-3l4%201v-9l-4%201c-4%200-4%200-4-2%200-3%200-3%204-3l4%201V93H6v24m19-18c0%201%200%202%201%201h2l4%201c2-1%203%200%203%201v1l1-1%209-1c8%200%209%200%209-2s0-2-4-2H40l-4%201h-1c0-1-1-1-2%201h-4c0-2%200-3-2-3s-2%200-2%203m1%209l-1%202c0%202%202%204%203%203h10c9%200%2010%200%2010-2h1c0%203%207%203%209%200%201-2-1-3-5-2h-5l-5%201h-1c0-1-2-2-8-1l-1%202h-1l-4-4-2%201m0%2012v5l1-1h1l3%201%203-1h1c0%201%200%202%201%201h10c7%200%208%200%208-2%200-1-1-2-4-2H36c-4%200-5%200-4%201l1%202-2-1c-1-3-4-5-5-3M3%20167v20h395v-41H3v21m1-1v20h393v-38l-197-1H4v19m28%208l-4%201c-3-1-6%201-5%203s4%201%205%200l1-2v1c-1%201%200%202%205%202s7-1%206-2l1-1%201%201%201%201c2%201%202%201%202-1l1%201h10c-1%203%201%202%202-1v-2H34c0-2-2-3-2-1\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/f19e500a46ea5e7a40aa8e2203909e4b/ca0a1/images-13110.webp 223w", "/static/f19e500a46ea5e7a40aa8e2203909e4b/75680/images-13110.webp 445w", "/static/f19e500a46ea5e7a40aa8e2203909e4b/b71d6/images-13110.webp 707w"],
                "sizes": "(max-width: 707px) 100vw, 707px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/f19e500a46ea5e7a40aa8e2203909e4b/e92b6/images-13110.png 223w", "/static/f19e500a46ea5e7a40aa8e2203909e4b/e66bf/images-13110.png 445w", "/static/f19e500a46ea5e7a40aa8e2203909e4b/394f7/images-13110.png 707w"],
                "sizes": "(max-width: 707px) 100vw, 707px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/f19e500a46ea5e7a40aa8e2203909e4b/394f7/images-13110.png",
                "alt": "First royalty statement",
                "title": "First royalty statement",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`First royalty statement`}</figcaption>{`
  `}</figure></p>
    <p>{`Great, the book sold exactly ten copies in its first month. And that means I made a negative 101 euro ... perfect. Just perfect.`}</p>
    <p>{`I was right confused, so I asked what's going on.`}</p>
    <blockquote>
      <p parentName="blockquote">{`Hello Sir, Thanks for sending in your query . We have forwarded your query to the accounts team and will get back to you as soon a we receive an update. Thanks. Regards, Invoices Team`}</p>
    </blockquote>
    <p>{`They never got back.`}</p>
    <p>{`At this point I was well bummed. The book surely a massive flop. Every time the editor contacted me about errata he'd open with `}<em parentName="p">{`"First of all I would like to congratulate you on the success of your book Data Visualization with d3.js."`}</em>{`.`}</p>
    <p>{`Psssht, yeah right. Sure.`}</p>
    <p>{`But two weeks ago I get an alert email from my bank. `}<em parentName="p">{`"577 euro has just been deposited to your account"`}</em></p>
    <p>{`U wot m8?`}</p>
    <p>{`I don't remember sending out any invoices. What is this mystery money? Where's it from? How am I going to explain this to the tax agency? What is going on here!?`}</p>
    <p>{`And sure enough, a few days later - new royalty statement from Packt.`}</p>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "890px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/3967f2730fd529a7b22803b4f154777e/daed9/images-13111.png",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "56.50224215246637%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'226\\'%20viewBox=\\'0%200%20400%20226\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M4%2017v13h392V3H4v14m2%200v12h389V4H6v13M4%2040v6h392V33H4v7m2%200v5h389V34H6v6m-2%2073v64h392V49H4v64m2%200v63h389V50H6v63m1-25v36h387V51H7v37m1-1v35h385V53l-193-1H8v35m188-31v4h4l5%201h2l4-1h5c1%202%203%200%202-2%200-2-1-2-4-2h-18m81%201c0%202%201%203%202%203h6c0-2%201-2%201-1h2l2%201h4l1-1h1l5%201%205-1c0-2-1-2-9-3l-9%201-1%201c-1-2-4-2-5-1h-1l-2-2-2%202m100-1h-6c-5%200-8%202-5%204h3c1-2%201-2%201%200-1%203%201%203%202%200%200-2%201-2%201-1%201%201%207%202%209%201h3c0%201%201%201%202-1h1c0%203%202%202%203-1%200-2%200-2-4-2h-10M9%2091l1%202%202%201h-2l-1%201h18c2%201%204%200%204-2l1%201c1%203%202%204%204%202l2-1%208-1h3c0-2-1-2-11-3-9%200-11%201-10%202v1l-1-1h-1l-1-1-2-1h-3c-1-1-2%200-3%201l-2%201h-1l-1-1c0-2-3-3-4-1m-2%2060v24h387v-49H7v25m1%200v23h385v-46l-193-1H8v24m27-7l-1%202c-1%201%202%201%207%201%207%200%208%200%208-2h1c0%202%201%202%204%202%204%200%205%200%205-2h1l1%202c1-1%201%200%201%201%200%202%202%201%203-2%200-3%200-3-4-3H48c-3%200-4%201-4%202s-1%201-1-1c-1-2-1-2-1%200h-1c-1-2-5-2-6%200m-8%2012c0%202%200%203%201%202h4l1%201%202-1c1-1%201-1%201%201h2c0-2%201-2%201-1%200%202%205%201%205-1h1c0%202%201%202%205%202l5-1v-2l-4-1-7-1h-1c0%202-11%202-12%200-2-2-4-1-4%202M4%20200l1%2021h391v-41H4v20m2%200v19h389v-38H6v19m34%200c0%202%201%205%202%203h4l1%201%202-1c1-1%201-1%201%201h2c0-2%201-2%201-1l7%201c5%200%206-1%206-2%200-2-2-3-2-2-1%201-2%200-4-1h-3l-1%201H45c-1-2-4-2-5%200m-7%208l-4%201-3%201c0%202%200%202%206%202h8c2%201%206%200%207-1h9c1-1%201-1%201%201-1%203%200%203%202-1v-2c-2%201-2%201-3-1h-1l-2%201h-5l-4-1c-3%200-3%200-2%202%202%200%202%201%201%201l-3-2-3-1h-1l-1-1-2%201m110%200v4l2-2h1l2%202%201-2%201%201c1%202%203%202%208%201l1-2h1l1%202c9%201%209%201%2010-2%200-3%200-3-2-2h-9c-2-1-2-1-2%201s0%202-1%201c0-2-8-2-9-1h-1c0-1-2-2-4-1\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/3967f2730fd529a7b22803b4f154777e/ca0a1/images-13111.webp 223w", "/static/3967f2730fd529a7b22803b4f154777e/75680/images-13111.webp 445w", "/static/3967f2730fd529a7b22803b4f154777e/8d1ba/images-13111.webp 890w", "/static/3967f2730fd529a7b22803b4f154777e/3838e/images-13111.webp 1335w", "/static/3967f2730fd529a7b22803b4f154777e/52cea/images-13111.webp 1426w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/3967f2730fd529a7b22803b4f154777e/e92b6/images-13111.png 223w", "/static/3967f2730fd529a7b22803b4f154777e/e66bf/images-13111.png 445w", "/static/3967f2730fd529a7b22803b4f154777e/4ef49/images-13111.png 890w", "/static/3967f2730fd529a7b22803b4f154777e/4e814/images-13111.png 1335w", "/static/3967f2730fd529a7b22803b4f154777e/daed9/images-13111.png 1426w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/3967f2730fd529a7b22803b4f154777e/4ef49/images-13111.png",
                "alt": "Winter royalty statement",
                "title": "Winter royalty statement",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`Winter royalty statement`}</figcaption>{`
  `}</figure></p>
    <p>{`Hey now, that's much better! 943 copies sold across all versions.`}</p>
    <p>{`Almost 600 euro made. Time to celebrate!`}</p>
    <p>{`But then again, total revenue was almost 6400 euro ... damn son. Not sure where all that money is going, but my chunk of the pie suddenly looks miniscule. And I `}<em parentName="p">{`think`}</em>{` I did most of the work.`}</p>
    <p>{`What really hurts though is that advance. You'll see the whole advance Packt gave me to write a book came `}<strong parentName="p">{`from my own damn pocket`}</strong>{`. Fuckers!`}</p>
    <p>{`You'd `}<em parentName="p">{`think`}</em>{` a royalty advance is something the publisher invests in a book. Nope. They take it right back as soon as they can.`}</p>
    <p>{`That means I've made about 1020 euro so far, Putting my effective hourly rate at 3 euro an hour. I'd be making more weighing tables at rundown restaurants. Tips not included.`}</p>
    <p>{`Not sure how I feel about this.`}</p>
    <p>{`PS: I'm giving a talk about writing my first technical book (this one) at this year's `}<a parentName="p" {...{
        "href": "http://conf.writethedocs.org/eu/2014/"
      }}>{`Write The Docs in Budapest`}</a>{`. If you're going to be there, I want to buy you a beer.`}</p>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/?px",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=d8bc3227-47c5-4cc4-b4b9-0c9a79b1c88f",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      